import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileUpload } from '../model/file-upload';
import { FirebaseService } from '../services/firebase.service';
import { UploadFileService } from '../services/upload-file.service';

@Component({
  selector: 'app-dash-agent',
  templateUrl: './dash-agent.component.html',
  styleUrls: ['./dash-agent.component.css']
})
export class DashAgentComponent implements OnInit {
  userid!:string;
  profileurl!:string;
  obj : any;
  data_target: any;
  username!:string;

  // basicdetails
  userfirstname!:string;
  phone!:string;
  aphone!:string;
  whatsapp!:string;
  email!:string;
  address!:string;
  useragentrefcode!: string;
  useragentaadhar!: string;
  appcurrentuser : any;
  // alter payment details
  gpayname!:string;
  gpay!:string;
  phpename!:string;
  phpe!:string;
  bankname!:string;
  accholname!:string;
  accnu!:string;
  ifsc!:string;
  sorc!:string;



  constructor(private router: Router, public firebaseService: FirebaseService,
    private firestore: AngularFirestore,private uploadService: UploadFileService) {
    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
  };
    console.log(this.obj.email);
    this.firestore.collection("users").ref.where("username", "==", this.obj.email).onSnapshot(snap =>{
      snap.forEach(userRef => {
        if(userRef.data()["role"] !== "agent"){

          var elements= document.getElementById('employee');
          elements.className = " display_none";
        }else{
    this.firestore.collection("users").ref.doc(this.obj.email)
    .get()
    .then((querySnapshot) => {
            this.profileurl = querySnapshot.data()['profileurl'];
            this.username = querySnapshot.data()["name"];
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
     // profile details
     this.firestore.collection("for-business").ref.where("email", "==", this.obj.email).get()
     .then((querySnapshot) => {
       querySnapshot.forEach((doc) => {
         this.userfirstname = doc.data()["name"],
         this.email = doc.data()["email"],
         this.useragentrefcode = doc.data()["reference_code"],
         this.phone = doc.data()["phoneno"],
         this.aphone = doc.data()["alternativeno"],
         this.useragentaadhar = doc.data()["aadharno"],
         this.address = doc.data()["address"]
        });
     })
     .catch((error) => {
         console.log("Error getting documents: ", error);
     });
     // payment alter details
     this.firestore.collection("for-business").ref.where("email", "==", this.obj.email).get()
     .then((querySnapshot) => {
       querySnapshot.forEach((doc) => {
        if(doc.data()["payment_updated"]!== "Updated"){
          var elements= document.getElementById('alteragentpayment');
          elements.className = " display_none";
          var elementspayment= document.getElementById('agentpayment');
          elementspayment.className = " display_pands";

          var navelements= document.getElementById('navagentaltpay');
          navelements.className = " display_none";
          var navelementspayment= document.getElementById('navagentpay');
          navelementspayment.className = " display_pands";

        }else{
          var elements= document.getElementById('alteragentpayment');
          elements.className = " display_pands";
          var elementspayment= document.getElementById('agentpayment');
          elementspayment.className = " display_none";

          var navelements= document.getElementById('navagentaltpay');
          navelements.className = " display_pands";
          var navelementspayment= document.getElementById('navagentpay');
          navelementspayment.className = " display_none";

        }
        this.gpayname = doc.data()["gpayname"],
        this.gpay = doc.data()["gpay"],
        this.phpename = doc.data()["phpename"],
        this.phpe = doc.data()["phonepe"],
        this.bankname = doc.data()["bankname"],
        this.accholname = doc.data()["accountholdername"],
        this.accnu = doc.data()["accountnumber"],
        this.ifsc = doc.data()["ifsc"],
        this.sorc = doc.data()["savingscurrent"]
        });
     })
     .catch((error) => {
         console.log("Error getting documents: ", error);
     });


   }
  })
})
  }
  ngOnInit(): void {
  }
// payment details
public paymentForm = new FormGroup({
  gpayname: new FormControl('',Validators.max(50)),
  gpay: new FormControl('',Validators.maxLength(50)),
  // paytm: new FormControl('',Validators.maxLength(50)),
  phpename: new FormControl('',Validators.max(50)),
  phpe: new FormControl('',Validators.maxLength(50)),
  bankname: new FormControl('',Validators.maxLength(50)),
  accholname: new FormControl('',Validators.maxLength(50)),
  accnu: new FormControl('',Validators.maxLength(50)),
  ifsc: new FormControl('',Validators.maxLength(50)),
  sorc: new FormControl('',Validators.maxLength(50)),
});
agent_payment_det(formData: FormData,id: string){
  let update_details={
    gpayname: formData["gpayname"],
    gpay: formData["gpay"],
    // paytm: formData["paytm"],
    phpename: formData["phpename"],
    phonepe: formData["phpe"],
    bankname: formData["bankname"],
    accountholdername: formData["accholname"],
    accountnumber: formData["accnu"],
    ifsc: formData["ifsc"],
    savingscurrent: formData["sorc"],
    payment_updated:"Updated"
  }

  this.firestore.collection("for-business").ref.where("email", "==", id).get()
  .then((querySnapshot) => {
    querySnapshot.forEach((doc) => {

      this.firestore.collection("for-business").doc(doc.id).update(update_details)
  .then(user => {
    var elements= document.getElementById('pay-succ');
  elements.className = " saved-ref";
  this.router.navigate(["/agent"]);

   }).catch(err => {
    console.log(err);
  })


     });
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });


}
  mob_click(){
    var elements= document.getElementById('agent');
    elements.className = " mobile-nav-active2";
    let btn = document.getElementById("mobia");
    if(btn.className === "bi bi-x mobile-nav-toggle2 d-xl-none"){
    btn.className = "bi bi-list mobile-nav-toggle2 d-xl-none";
    elements.className = "";
    }else{
    btn.className = "bi bi-x mobile-nav-toggle2 d-xl-none";
    }
  }
  selectedAgentProfFiles: FileList;
  currentFileAgentProfUpload: FileUpload;
  percentageAgentProf: number;


selectAgentProfFile(event) {
  this.selectedAgentProfFiles = event.target.files;
}

upload() {
  const file = this.selectedAgentProfFiles.item(0);
  this.selectedAgentProfFiles = undefined;
  this.currentFileAgentProfUpload = new FileUpload(file);
  this.uploadService.pushAgentProfilePicFileToStorage(this.currentFileAgentProfUpload).subscribe(
    percentage => {
      this.percentageAgentProf = Math.round(percentage);
    },
    error => {
      console.log(error);
    }
  );
}
copyCode(useragentrefcode : any){
  let selBox!: any;
    selBox = document.getElementById(useragentrefcode);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    console.log("selBox"+selBox);
    document.body.removeChild(selBox);

  window.alert("Copied the Reference Code: " + selBox.value);
}
loggedout(){
  this.firebaseService.logOut();
}
}
